'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresReservationPaymentMethodController = function () {
    function WinresReservationPaymentMethodController($scope, reservationService, localizationService, $filter) {
        _classCallCheck(this, WinresReservationPaymentMethodController);

        this.$scope = $scope;
        this.reservationService = reservationService;
        this.localizationService = localizationService;
        this.$filter = $filter;
    }

    _createClass(WinresReservationPaymentMethodController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Is initialized when the user clicks to go to payment.
            // Completes when the prebook request finishes.
            // Used to display a loading indicator in place of the right arrow.
            this.toPaymentRequest = undefined;

            if (this.providedPaymentMethod) {
                this.setPaymentMethod(this.providedPaymentMethod);
                this.internalName = this.providedPaymentMethod.InternalName;
            } else {
                this.$scope.$watch(function () {
                    return _this.winresReservationPayment.getPaymentMethod(_this.internalName);
                }, function (paymentMethod) {
                    return _this.setPaymentMethod(paymentMethod);
                }
                // No need to deep watch, since if the object changes, it is new data
                // from the backend and thus an entirely new object.
                );
            }

            this.mode = this.winresReservationPayment.mode || 'buttons';

            this.data = this.winresReservationPayment.data;
        }
    }, {
        key: 'setPaymentMethod',
        value: function setPaymentMethod(paymentMethod) {
            this.paymentMethod = paymentMethod;
            if (paymentMethod) {
                this.title = this.title ? this.title : paymentMethod.Name;
                this.fee = paymentMethod.Fee;
                this.logo = this.logo || paymentMethod.Logo;
            } else {
                this.fee = null;
            }
        }
    }, {
        key: 'Pay',
        value: function Pay() {
            var _this2 = this;

            if (this.toPaymentRequest) {
                // We already have an ongoing request, don't allow the user to start another.
                console.log('[PaymentMethod] Already going to payment. Disregarding second click.');
                return;
            }

            if (this.data.AcceptTerms) {
                this.toPaymentRequest = this.winresReservationPayment.toPayment(this.internalName);
                // If toPaymentRequest resolves to true, prebook succeeded and we are being redirected.
                // If it resolves to false or throws an error, something went wrong and we are not
                // being redirected. In that case, we should let the user try again.
                this.toPaymentRequest.catch(function () {
                    return false;
                }).then(function (success) {
                    if (success) {
                        // We are currently being redirected somewhere.
                        // Keep the spinner spinning and ignore any new clicks.
                    } else {
                        // Got an error. Let the user try again for now.
                        _this2.toPaymentRequest = undefined;
                    }
                });
            } else {
                alert(this.$filter('i18next')('reservation_customer.error_terms'));
                this.toPaymentRequest = undefined;
            }
        }
    }]);

    return WinresReservationPaymentMethodController;
}();

WinresReservationPaymentMethodController.$inject = ['$scope', 'reservationService', 'localizationService', '$filter'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'payment-method';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('payment-method', require('./winresReservationPaymentMethod.html'));
}]);

_module3.default.component('winresReservationPaymentMethod', {
    templateUrl: getTemplate,
    controller: WinresReservationPaymentMethodController,
    require: {
        winresReservationPayment: '^^winresReservationPayment'
    },
    bindings: {
        // Logo image url
        logo: '@',

        // The payment method object from GetPaymentmethods.
        providedPaymentMethod: '<paymentMethod',

        // Payment method internal name. example VM, VMLK.
        // Used to find the payment method if _paymentMethod is not provided.
        internalName: '@',

        // Payment method title
        title: '@titleOverride',

        // Unused
        terms: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationPaymentMethod/winresReservationPaymentMethod.js
// module id = 410
// module chunks = 2